import { Button } from 'shared/ui/Button'
import cls from './EmptyCollectionPage.module.scss'
import { useNavigate } from 'react-router-dom'
import whale from 'shared/assets/images/whaleDontKnow.png'
import { Text } from 'shared/ui/Text/Text'
import React from 'react'
import { CheckCircleIcon } from 'shared/ui/Icon'

const EmptyCollectionPage = (props) => {
    const { switcher, readonly } = props

    const navigate = useNavigate()

    const onRedirect = () => {
        navigate('/')
    }

    const onRedirectToSuggest = () => {
        navigate('/suggest')
    }

    if (readonly) {
        return (
            <div className={cls.EmptyCollectionPage}>
                <img className={cls.Image} src={whale} alt="whale" />
                <div className={cls.Title}>Пока тут пусто</div>
                <Text>Заходи в другой раз</Text>
            </div>
        )
    }

    if (switcher === 'created') {
        return (
            <div className={cls.EmptyCollectionPage}>
                <img className={cls.Image} src={whale} alt="whale" />
                <div className={cls.Title}>Список созданного пока пуст</div>
                <Text className={cls.Second}>
                    Создай свою мечту и её увидят все пользователи MineCards!
                </Text>
                <Button
                    className={cls.Button}
                    onClick={onRedirectToSuggest}
                    text={'Создать свой мечту'}
                />
            </div>
        )
    }

    if (switcher === 'rejected') {
        return (
            <div className={cls.EmptyCollectionPage}>
                <img className={cls.Image} src={whale} alt="" />
                <div className={cls.Title}>Архив пока пуст</div>
                <Text className={cls.Second}>
                    Здесь появятся карточки, которые ты пропустил
                </Text>
                <Button
                    className={cls.Button}
                    onClick={onRedirect}
                    text="Смотреть достижения"
                />
            </div>
        )
    }

    return (
        <div className={cls.EmptyCollectionPage}>
            <img className={cls.Image} src={whale} alt="whale" />
            <div className={cls.Title}>Список достижений пока пуст</div>
            <Text>
                Чтобы помнить о своих достижениях, отмечай моменты галочкой
                <CheckCircleIcon className={cls.InlineIcon} />
            </Text>
            <Button
                className={cls.Button}
                onClick={onRedirect}
                text={'Искать достижения'}
            />
        </div>
    )
}

export default EmptyCollectionPage
